// Module
var code = "<query-editor-row query-ctrl=\"ctrl\" has-text-edit-mode=\"true\">\n  <graphite-query-editor state=\"ctrl.state\" dispatch=\"ctrl.dispatch\"></graphite-query-editor>\n</query-editor-row>\n";
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/datasource/graphite/partials/query.editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;